import React from 'react'
import {connect} from 'react-redux'
import {Flex, SVGButton, Modal} from '/app/src/component';
import {FAQModel} from '/app/src/model'



class RemoveItemModal extends React.Component {

    render(){

        const { open, onClose, item} = this.props

        return (
            <Modal
                title='Ta bort fråga'
                open={open}
                onClose={onClose}>
            <Flex column w='100%' hAlignContent='center' my='25px'>
                <Flex color='#404040' fontSize='24px' mt='30px' padding='40px' textAlign='center'>
                    Är du säker på att du vill ta bort frågan? All feedback till frågan kommer
                    att tas bort. Detta går inte att ångra.
                </Flex>
                <Flex row padding='50px'>
                    <SVGButton src='/images/Return.svg' text='Avbryt' border
                    hover='blue'
                    borderRadius='40px' fontSize='26px' mr='20px'
                    onClick={() => onClose()}/>
                    <SVGButton src='/images/Trash.svg' text='Ta bort' border
                    hover='red'
                    borderRadius='40px' fontSize='26px' mr='20px'
                    onClick={() => {
                        this.props.removeItem(item.id);
                        //Reset right panel
                        this.props.setCurrentItem(null);
                        onClose();
                    }}/>
                </Flex>
            </Flex>
        </Modal>
        )
    }
}

const {dispatcher: removeItemDispatch} = FAQModel.removeItemRequest();
const {dispatcher: setCurrentItem} = FAQModel.setCurrentItem();


const mapDispatchToProps = (dispatch, props) => ({
    removeItem: (faqId) => dispatch(removeItemDispatch(faqId)),
    setCurrentItem: (id) => dispatch(setCurrentItem(id))
})

function mapStateToProps(state, props){
   return {
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveItemModal);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Category/RemoveItemModal.js